module.exports = __webpack_public_path__ + "static/media/19.ff03d8aa.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/19.JPG
// module id = 223
// module chunks = 0